import { render, staticRenderFns } from "./OtherRating.vue?vue&type=template&id=3122f13a&scoped=true"
import script from "./OtherRating.vue?vue&type=script&lang=js"
export * from "./OtherRating.vue?vue&type=script&lang=js"
import style0 from "./OtherRating.vue?vue&type=style&index=0&id=3122f13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122f13a",
  null
  
)

export default component.exports